<script lang="ts">
    import Select from "svelte-select"
    import { getDealer } from "../../api"
    import { login } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { searchDealer } from "./operations/OperationsFilter.svelte"
    import { renzShopUrl } from "../../../../api/hooks/config-client"
    import { requireLogin, tooltip } from "../../helper"
    import { debounce } from "lodash"
    import Icon from "../widgets/Icon.svelte"
    import { mdiInformationOutline } from "@mdi/js"
    import Checkbox from "../widgets/Checkbox.svelte"
    import { _ } from "svelte-i18n"
    export let lang = "de"

    let integration: { [key: string]: any } = {
        type: "iframe",
        theme: "light",
        backgroundColor: "",

        firstname: "Max",
        lastname: "Mustermann",
        company: "Musterfirma",
        city: "Musterstadt",
        street: "Musterstraße",
        houseNumber: "1",
        postcode: "12345",
        countryCode: "DE",
        email: "max@mustermail.de",
        phone: "0123456789",

        preDef: false,
    }

    let init = true

    requireLogin()

    let dealerNumbers: number[] = []
    let dealerSelect: any = {
        value: null,
        label: null,
    }

    $: isRenz = $login?.account?.roles?.includes("A") || $login?.account?.roles?.includes("R")

    $: if (init && $login?.account?.ident?.dealerNumber) {
        init = false
        dealerNumbers = [$login.account.ident.dealerNumber]
        dealerSelect.value = $login.account.ident.dealerNumber
        dealerSelect.label = $login.account.ident.dealerNumber
    }

    $: if (isRenz) {
        dealerNumbers = dealerSelect?.value ? [dealerSelect.value] : []
    }

    const preDefs = [
        ["firstname", $_("integrations.integrationsMap.firstname")],
        ["lastname", $_("integrations.integrationsMap.lastname")],
        ["company", $_("integrations.integrationsMap.company")],
        ["city", $_("integrations.integrationsMap.city")],
        ["street", $_("integrations.integrationsMap.street")],
        ["houseNumber", $_("integrations.integrationsMap.houseNumber")],
        ["postcode", $_("integrations.integrationsMap.postcode")],
        ["countryCode", $_("integrations.integrationsMap.countryCode")],
        ["email", $_("integrations.integrationsMap.email")],
        ["phone", $_("integrations.integrationsMap.phone")],
    ]

    $: preDefURLsuffix = integration.preDef ? "&" + preDefs.map((e) => e[0] + "=" + integration[e[0]]).join("&") : ""

    let customizedTheme = ""
    const setCustomizedTheme = debounce(() => {
        if (integration.backgroundColor) {
            customizedTheme =
                "&customized-theme=background|" +
                integration.backgroundColor +
                ",surface|" +
                integration.backgroundColor
        } else {
            customizedTheme = ""
        }
    }, 500)
    $: if (integration.backgroundColor) {
        setCustomizedTheme()
    } else {
        customizedTheme = ""
    }

    $: iframeCode =
        `<iframe 
    src="${renzShopUrl}brief-und-paketkaesten/konfigurator?iframe=1&d=` +
        dealerNumbers.join(",") +
        "&theme=" +
        integration?.theme +
        customizedTheme +
        preDefURLsuffix +
        `"
    width="100%"
    height="800px"
></iframe>`

    let integrationTypeValues: { [key: string]: string } = {
        iframe: "iFrame",
        link: "Link",
    }

    let integrationType = {
        label: integration?.type ? integrationTypeValues[integration?.type] : null,
        value: integration?.type || null,
    }
    $: {
        integration.type = integrationType.value
    }

    let integrationThemeValues: { [key: string]: string } = {
        light: "hell",
        dark: "dunkel",
    }

    let integrationTheme = {
        label: integration?.theme ? integrationThemeValues[integration.theme] : null,
        value: integration?.theme || null,
    }
    $: {
        integration.theme = integrationTheme.value
    }
</script>

<style lang="less">
    .code {
        background-color: #eee;
        padding: 20px;
    }
    code {
        white-space: pre-wrap;
        overflow-wrap: break-word;
    }
    .dealerError {
        border: 1px solid darkred;
        color: darkred;
        padding: 20px;
        margin-top: 20px;
        background-color: rgb(255, 238, 238);
    }
    .preDef {
        th {
            text-align: left;
        }
        th,
        td {
            padding-right: 20px;
            padding-top: 5px;
            padding-bottom: 5px;
            vertical-align: baseline;
        }
    }
</style>

<section class="section_padding" data-lang="{lang}">
    <div class="container">
        <h1>{$_("integrations.configIntegrations")}</h1>
        <p>
            {@html $_("integrations.iframeRecommendation")}
        </p>
        <div class="row">
            <div class="col-md-2">
                <label for="">{$_("general.type")}</label>

                <Select
                    placeholder="{$_('general.selectType')}"
                    items="{Object.entries(integrationTypeValues).map((e) => ({ label: e[1], value: e[0] }))}"
                    bind:value="{integrationType}"
                    hideEmptyState
                    clearable="{false}"
                />
            </div>
            <div class="col-md-2">
                <label for="">{$_("integrations.colorStyle")}</label>
                <Select
                    placeholder="{$_('integrations.selectColorStyle')}"
                    items="{Object.entries(integrationThemeValues).map((e) => ({ label: e[1], value: e[0] }))}"
                    bind:value="{integrationTheme}"
                    hideEmptyState
                    clearable="{false}"
                />
            </div>
            <div class="col-md-3">
                <label for="">{$_("integrations.backgroundColor")}</label>
                <input
                    type="text"
                    placeholder="HEX-Code, z.B. 3f3f3f"
                    bind:value="{integration.backgroundColor}"
                    data-cy="background-color"
                />
            </div>
            <div class="col-md-5" data-cy="dealer">
                {#if isRenz}
                    <label for="">{$_("integrations.dealerCustomer")}</label>
                    <Select
                        placeholder="{$_('integrations.enterNumberOrName')}"
                        loadOptions="{searchDealer}"
                        bind:value="{dealerSelect}"
                        hideEmptyState
                    />
                {:else if $login?.tokenData?.dealers?.length}
                    <label for="">{$_("integrations.dealerCustomers")}</label>
                    {#await getDealer(null, null, null, "full", null, 2)}
                        {$_("general.pleaseWait")}
                    {:then d}
                        {#each d.data?.sort((a, b) => {
                            if (a.number == $login.account.ident.dealerNumber) {
                                return -1
                            }
                            if (b.number == $login.account.ident.dealerNumber) {
                                return 1
                            }
                            return a.number < b.number ? -1 : 1
                        }) || [] as dealer (dealer.number)}
                            <div
                                style="overflow:hidden; white-space: nowrap;{!dealer.inquiry_ok ||
                                dealer.missingTemplate
                                    ? 'color: gray;'
                                    : ''}"
                            >
                                <input type="checkbox" bind:group="{dealerNumbers}" value="{dealer.number}" />

                                {#if dealer.number === $login.account.ident.dealerNumber}
                                    <!-- hauptnummer -->
                                {:else}
                                    ⌞
                                {/if}
                                {dealer.number} -
                                {dealer.company} &nbsp;
                                {#if !dealer.inquiry_ok || dealer.missingTemplate}
                                    <span
                                        use:tooltip="{{
                                            content: $_('integrations.dealerIsntAvailable'),
                                        }}"
                                    >
                                        <Icon
                                            path="{mdiInformationOutline}"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        />
                                    </span>
                                {/if}
                            </div>
                        {/each}
                    {/await}
                {:else}
                    <label for="">{$_("integrations.dealerCustomer")}</label>
                    {$login?.account?.ident?.dealerNumber}
                {/if}
            </div>
        </div>

        {#if dealerNumbers?.length}
            {#await getDealer({ number: { $in: dealerNumbers }, inquiry_ok: true }, null, null, "autocomplete", null, 1)}
                <MiniLoader />
            {:then d}
                {#if d?.data?.length}
                    <h2>{$_("integrations.sourceCode")}</h2>
                    {#if integration?.type == "link"}
                        <div class="code">
                            <code data-cy="link-code">
                                {`<a href="${renzShopUrl}brief-und-paketkaesten/konfigurator?d=` +
                                    dealerNumbers.join(",") +
                                    "&theme=" +
                                    integration?.theme +
                                    customizedTheme +
                                    preDefURLsuffix +
                                    '">Renz-Konfigurator</a>'}
                            </code>
                        </div>
                    {:else}
                        <p>
                            {@html $_("integrations.iframeRecommendation")}
                        </p>
                        <div class="code" data-cy="iframe-code">
                            <code>
                                {iframeCode}
                            </code>
                        </div>
                        <h2>{$_("integrations.preview")}</h2>

                        {@html iframeCode}
                    {/if}

                    <h2>{$_("integrations.contactDataPrepopulation")}</h2>
                    <p>
                        {$_("integrations.useCustomerData")}
                    </p>
                    <p>{$_("integrations.fieldsToPrepopulate")}</p>
                    <p>&nbsp;</p>

                    <div class="preDef">
                        <table>
                            <tr>
                                <th>{$_("integrations.fieldName")}</th>
                                <th>{$_("integrations.importance")}</th>
                                <th>{$_("integrations.example")}</th>
                            </tr>
                            {#each preDefs as f}
                                <tr>
                                    <td><code>{f[0]}</code></td>
                                    <td>{f[1]}</td>
                                    <td
                                        ><input
                                            type="text"
                                            bind:value="{integration[f[0]]}"
                                            data-cy="contact-prep-input"
                                        /></td
                                    >
                                </tr>
                            {/each}
                        </table>
                        <br /><br />
                        <Checkbox bind:checked="{integration.preDef}" label=" ">
                            {$_("integrations.preDefInsert", {
                                values: {
                                    additionalInfo:
                                        integration?.type == "iframe" ? $_("integrations.iframePreview") : "",
                                },
                            })}
                            <br />
                        </Checkbox>
                        <br />
                    </div>
                {:else}
                    <div class="dealerError">
                        <p>
                            {$_("integrations.dealerErrorHeader", {
                                values: {
                                    dealerNumbers: dealerNumbers.join(", "),
                                },
                            })}
                        </p>
                        <p>
                            {$_("integrations.dealerErrorInstructions")}
                        </p>
                    </div>
                {/if}
            {/await}
        {/if}
    </div>
</section>
